import { render, staticRenderFns } from "./ToolbarTemplate.vue?vue&type=template&id=0d867fa7&"
import script from "./ToolbarTemplate.vue?vue&type=script&lang=js&"
export * from "./ToolbarTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports